import { useLocation } from "react-router-dom";

export const useOnHr = () => {
  const location = useLocation();

  return location.pathname.includes("/hr");
};
